module.exports = __webpack_public_path__ + "static/media/c3.f91a75bb.jpg";